import React, { Component } from 'react';
import { Row, Col, Container, PureGridProvider } from '../3rdparty/react-pure-grid';
import i from '../imports';
import c from '../components';
import Session from '../services/session'

class Banner extends Component {

    constructor(props) {
        super(props);

    }

    render() {

        if (this.props.images === undefined || this.props.images.length < 1)
            return null;

        let blogItems = i.Utils.sortByDate(Session.model.blogPages.filter(b => b.lang === Session.model.home.lang), true).slice(0,2);

        //let discounts = Session.model.discounts;
        let discounts = [];

        return (
            <div>
                <div style={{ position: 'relative',  marginLeft: 0, marginRight: 0 }}>
                    <i.SlickSlider
                        autoplay={true}
                        wrapAround={true}
                        arrows={false}
                        initialSlideWidth={160} initialSlideHeight={60} renderCenterLeftControls={({ previousSlide }) => (<span />)}
                        renderBottomCenterControls={() => null} renderCenterRightControls={() => null}
                    >
                        {this.props.images.map((i, index) => <img onLoad={() => { window.dispatchEvent(new Event('resize')); }} key={index} src={i} />)}
                    </i.SlickSlider>

                    {/*discounts.length > 0 ?
                        <div style={{ paddingLeft: 40, paddingRight: 40, marginTop: -150, position: "relative", zIndex: 10 }}>
                            <div style={{ position: "absolute", left: 0, top: 0, width: "100%", height: "100%", backgroundColor: "gray", opacity: 0.6 }}></div>
                            <i.OnAtMostTablet>
                                <c.Slider items={discounts} itemComponent={c.DiscountItem} navColor="white" autoplay={true} slidesToShow={1} />
                            </i.OnAtMostTablet>
                            <i.OnDesktop>
                                <c.Slider items={discounts} itemComponent={c.DiscountItem} navColor="white" autoplay={true} slidesToShow={Math.min(discounts.length, 3)} />
                            </i.OnDesktop>
                        </div>
                        : null
                    */}

                    <i.OnAtLeastTablet>
                        <div style={{ position: 'absolute', left: 0, top: 0, width: "100%", marginTop: "1%", zIndex: 10 }}>
                            <i.PureGridProvider gutterSize={0}>
                                <i.Row justify="end">
                                    <i.Col md={4} sm={6}>
                                        {blogItems.map(b => <c.BlogCard item={b} />)}
                                    </i.Col>
                                </i.Row>
                            </i.PureGridProvider>
                        </div>
                    </i.OnAtLeastTablet>

                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: '#00000000' }}>
                        <PureGridProvider maxWidth={'auto'} gutterSize={0}>
                            <Container fluid={true}>
                                <Row style={{ marginTop: '5%', marginLeft: 0, color: 'white'}}>
                                    <Col xsOffset={1}>
                                        <Row>
                                            <Col align='left' style={{width:"100%", backgroundColor: '#00000000', textShadow: "1px 1px 2px black, 0 0 1em black, 0 0 2em black"}}>
                                                <div style={{ marginLeft: 20, marginBottom: 0, fontSize: 36, fontWeight: 400 }}>{this.props.title}</div>
                                                <div style={{ marginLeft: 40, marginTop: 0, fontSize: 20 }}>{this.props.text}</div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Container>
                        </PureGridProvider>
                    </div>
                </div>

                <i.OnAtMostPhablet>
                    <h2>{Session.model.navigation.blog}</h2>
                    {blogItems.map(b => <c.BlogCard item={b} bgStyle={{backgroundColor: "black", opacity: 0.72 }} containerStyle={{ color: "white",}} />)}
                </i.OnAtMostPhablet>
                

            </div>
        );
    }
}

export default Banner;